<template>
  <div
    class="d-flex justify-content-between sticky-view-header"
    :class="[compact ? 'py-4' : 'py-6']"
  >
    <Text size="h1">
      {{ title || $route.meta.label || $route.name }}
    </Text>
    <div class="d-flex align-items-center" style="gap: 24px;">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewHeader",
  props: {
    title: String,
    compact: Boolean,
  }
}
</script>

<style>
.sticky-view-header {
  position: sticky;
  top: 45px;
  z-index: 1000;
  background-color: white;
}
</style>
